import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Pagination from 'components/ui/pagination';

import {
  getDuplicateCompaniesPage,
  getDuplicateCompaniesPageCount
} from '../../store/selectors/duplicates';
import { retrieveCompaniesDuplicates } from 'bundles/contact/index/store/actions/duplicates';

export function DuplicatesPagination({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  return (
    <Pagination
      currentPage={currentPage}
      totalPages={totalPages}
      onChange={onPageChange}
    />
  );
}

DuplicatesPagination.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  onPageChange: PropTypes.func
};

const mapStateToProps = state => ({
  currentPage: getDuplicateCompaniesPage(state),
  totalPages: getDuplicateCompaniesPageCount(state)
});

const mapDispatchToProps = {
  onPageChange: retrieveCompaniesDuplicates
};

export default connect(mapStateToProps, mapDispatchToProps)(DuplicatesPagination);
